// extracted by mini-css-extract-plugin
export default {"wrapper":"H025v","title":"pdwTt","subtitle":"omvir","cards":"L3IcH"};